module.exports = __webpack_public_path__ + "static/media/ZETH.18708d3e.svg";